import {SubmitButton} from "../input/submitButton";
import React, {useEffect, useState} from "react";
import {useGlobalContext, useUserContext} from "../../hooks/globalContext";
import {InputText} from "../input/inputText";
import {FormWithLoader} from "../loader/formWithLoader";
import {InputPhone} from "../input/phoneInput";
import {Phone} from "../../models/other/phone";
import {YandexSettings} from "../../models/requests/yandexSettings";

export function YandexSettingsForm() {
    const {i18n, api} = useGlobalContext()
    const {user} = useUserContext()
    const organizationId = user?.org?.id;
    const [clearToken,setClearToken] = useState(false);
    const [apiKey, setApiKey] = useState<string>("")
    const [restaurantContactName, setRestaurantContactName] = useState<string>("")
    const [restaurantContact, setRestaurantContact] = useState<Phone>({} as Phone)
    const [due, setDue] = useState<number>(0);
    const [safeSettingsAPI,setSafeSettingsAPI] = useState(false);
    const [checkoutEnabled,setCheckoutEnabled] = useState<boolean | undefined>();
    const [settingsError,setSettingsError] = useState("");
    const [tokenConfigured, setTokenConfigured] = useState(false);

    const [loading, setLoading] = useState<boolean>(false)
    const [createDeleteLoading, setCreateDeleteLoading] = useState<boolean>(false)

    useEffect(() => {
        const controller = new AbortController()
        setSafeSettingsAPI(false);setCheckoutEnabled(undefined);setTokenConfigured(false);setApiKey("");setClearToken(false);setSettingsError("");
        setRestaurantContactName("");setRestaurantContact({number:"",countryCode:"kz"});setDue(0);
        if (organizationId) {
            api.getYandexSettings({controller, setLoading}, organizationId).then((res) => {
                if (controller.signal.aborted) return;
                if (res.data) {
                    setSafeSettingsAPI(typeof res.data.tokenConfigured === "boolean");
                    if (typeof res.data.tokenConfigured !== "boolean") setSettingsError("Сохранение недоступно: обновите сервер настроек Яндекса.");
                    setTokenConfigured(Boolean(res.data.tokenConfigured));
                    setCheckoutEnabled(res.data.checkoutEnabled);
                    setRestaurantContactName(res.data.restaurantContactName || "")
                    setRestaurantContact({
                        number: res.data.restaurantContactPhone || "",
                        countryCode: "kz"
                    } || {number: "", countryCode: "kz"})
                    setDue(res.data.number || 0)
                } else setSettingsError("Не удалось загрузить настройки. Обновите страницу и повторите попытку.");
            }).catch(() => {if (!controller.signal.aborted) setSettingsError("Не удалось загрузить настройки. Обновите страницу и повторите попытку.");})
        }
        return () => controller.abort()
    }, [organizationId, api])

    function onSave() {
        if (!safeSettingsAPI || (clearToken && apiKey.trim())) return;
        const yandexRequest: YandexSettings = {
            organizationId: user?.org?.id,
            token: clearToken ? "" : apiKey.trim(),
            ...(clearToken ? {clearToken:true} : {}),
            restaurantContactName: restaurantContactName,
            restaurantContactPhone: restaurantContact.number,
            number: due,
        }

        api.createYandexTokenSettings({setLoading: setCreateDeleteLoading}, yandexRequest).then((res) => {
            if (res.data) {
                setTokenConfigured(!clearToken && (tokenConfigured || Boolean(apiKey.trim())));
                setClearToken(false);
                setApiKey("");
            }
        })
    }

    return (
        <FormWithLoader isloading={loading} className="form">
            {checkoutEnabled === false && <p>Доставка скрыта от гостей, пока автоматический вызов курьера отключён на сервере.</p>}
            {settingsError && <p role="alert">{settingsError}</p>}
            <InputText label={i18n.api_key()} value={apiKey} onChange={value => {setApiKey(value);if(value.trim()) setClearToken(false);}} isValidate={true}/>
            <label><input type="checkbox" checked={clearToken} disabled={!tokenConfigured || createDeleteLoading || Boolean(apiKey.trim())} onChange={event=>setClearToken(event.target.checked)}/> Удалить сохранённый ключ при сохранении</label>
            {clearToken && <p>Новые доставки будут недоступны. Уже созданные заявки отменяйте в кабинете Яндекса.</p>}
            <p>{tokenConfigured ? "Ключ сохранён. Оставьте поле пустым, чтобы сохранить текущий ключ." : "Введите ключ Яндекс Доставки для этого заведения."}</p>
            <InputText label={"Представитель ресторана"} value={restaurantContactName}
                       onChange={setRestaurantContactName} isValidate={true}/>
            <InputPhone label={"Номер телефона ресторана"} value={restaurantContact}
                        onChange={setRestaurantContact}/>
            <InputText label={"Через сколько минут нужен курьер"} value={String(due)}
                       onChange={(num: string) => {
                           let temp = Number(num)
                           if (isNaN(temp)) {
                               temp = 0
                           }
                           setDue(Number(temp))
                       }} isValidate={true}/>
            <div className="form__buttons mt-4">
                <div className="form__buttons-left">
                    <SubmitButton onSubmit={onSave} label={i18n.save()}
                                  disabled={!safeSettingsAPI || (!tokenConfigured && !apiKey.trim())} isLoading={createDeleteLoading}
                                  modal={true}/>
                </div>
            </div>
        </FormWithLoader>
    )
}
